msgid ""
msgstr ""
"POT-Creation-Date: 2024-10-18 02:14+0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: ru\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/domains/buy-ticket/select-seats.tsx:83
msgid "{remainingSeatCount, plural, =0 {Места выбраны} =1 {Осталось выбрать 1 место} =2 {Осталось выбрать 2 места} =3 {Осталось выбрать 3 места} =4 {Осталось выбрать 4 места} other {}}"
msgstr ""

#: src/components/train-route-info/train-route-info.tsx:31
msgid "Hч mmм"
msgstr ""

#: src/domains/sign-in/sign-in.tsx:47
#: src/domains/sign-up/sign-up.tsx:36
msgid "Авторизация не удалась"
msgstr ""

#: src/domains/buy-ticket/buy-ticket.tsx:227
#: src/domains/buy-ticket/buy-ticket.tsx:228
#: src/domains/buy-ticket/select-payment-type.tsx:10
#: src/domains/buy-ticket/select-payment-type.tsx:10
msgid "Банковской картой"
msgstr ""

#: src/pages/ticket-details/ticket-details.page.tsx:188
msgid "Билет не найден. Попробуйте обновить страницу или вернуться к списку билетов"
msgstr ""

#: src/pages/my-tickets/my-tickets.page.tsx:66
msgid "Билеты пока что отсутствуют"
msgstr ""

#: src/pages/sign-up/sign-up.page.tsx:50
msgid "в личном кабинете"
msgstr ""

#: src/domains/push-notify/push-notify-settings.tsx:38
msgid "В настройках вашего браузера запрещено показывать уведомления для этого приложения"
msgstr ""

#: src/domains/push-notify/push-notify-settings.tsx:30
msgid "В настройках вашего телефона запрещено показывать уведомления для этого приложения"
msgstr ""

#: src/domains/buy-ticket/select-seats.tsx:149
msgid "Вагон"
msgstr ""

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:29
msgid "Вагон и место"
msgstr ""

#: src/domains/push-notify/push-notify-settings.tsx:26
msgid "Ваше устройство не поддерживает Web Push уведомления"
msgstr ""

#: src/domains/available-routes/ui/select-stations.tsx:115
msgid "Введите название станции"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:36
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:43
msgid "Вернуть билет"
msgstr ""

#: src/App.tsx:69
msgid "Версия"
msgstr ""

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:29
msgid "Вид тарифа"
msgstr ""

#: src/domains/push-notify/push-notify-access-request.tsx:58
msgid "Включить уведомления"
msgstr ""

#: src/domains/buy-ticket/agreement.tsx:16
msgid "Внимание!"
msgstr ""

#: src/domains/sign-in/sign-in.tsx:135
#: src/features/main-side-menu/main-side-menu.tsx:73
#: src/pages/sign-up/sign-up.page.tsx:91
msgid "Войти"
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:176
msgid "Войти в личный кабинет"
msgstr ""

#: src/pages/order-status/order-status.page.tsx:328
msgid "Все оплаченные билеты доступны в разделе <0>Мои билеты</0>."
msgstr ""

#: src/pages/main/main.page.tsx:106
msgid "Вход"
msgstr ""

#: src/pages/sign-in/sign-in.page.tsx:49
msgid "Вход в личный кабинет"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:37
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:46
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:59
msgid "Вы уверены, что хотите отменить заказ?"
msgstr ""

#: src/domains/buy-ticket/select-seats.tsx:63
#: src/domains/buy-ticket/select-seats.tsx:68
msgid "Выберите место"
msgstr ""

#: src/pages/buy-tickets/buy-tickets.tsx:24
msgid "Выбор мест"
msgstr ""

#: src/pages/main/main.page.tsx:112
msgid "Выбор языка"
msgstr ""

#: src/domains/buy-ticket/buy-ticket.tsx:244
msgid "Выбрать место"
msgstr ""

#: src/pages/logout/logout.page.tsx:60
msgid "Выполняется выход из приложения..."
msgstr ""

#: src/domains/buy-ticket/redirect-to-bank.tsx:18
msgid "Выполняется переход на сайт банка для оплаты. Если этого не произошли, нажмите на ссылку"
msgstr ""

#: src/features/main-side-menu/main-side-menu.tsx:64
msgid "Выход"
msgstr ""

#: src/domains/buy-ticket/select-seats.tsx:78
msgid "Голова поезда находится в верху экрана"
msgstr ""

#: src/pages/ticket-details/ticket-details.page.tsx:116
#: src/pages/ticket-details/ticket-details.page.tsx:141
#: src/pages/ticket-details/ticket-details.page.tsx:224
msgid "Данные билета"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:85
#: src/pages/order-details/order-details.page.tsx:122
#: src/pages/order-details/order-details.page.tsx:169
#: src/pages/order-details/order-details.page.tsx:224
#: src/pages/order-status/order-status.page.tsx:93
#: src/pages/order-status/order-status.page.tsx:118
#: src/pages/order-status/order-status.page.tsx:153
#: src/pages/ticket-details/ticket-details.page.tsx:177
#: src/pages/ticket-details/ticket-details.page.tsx:302
msgid "Данные заказа"
msgstr ""

#: src/domains/buy-ticket/pay-confirm.tsx:23
#: src/pages/order-status/order-status.page.tsx:358
msgid "Дата"
msgstr ""

#: src/pages/my-tickets/my-tickets.page.tsx:79
#: src/pages/order-details/order-details.page.tsx:45
#: src/pages/ticket-details/ticket-details.page.tsx:78
msgid "Дата заказа"
msgstr ""

#: src/domains/available-routes/features/available-routes/available-routes.tsx:162
#: src/domains/available-routes/features/available-routes/available-routes.tsx:163
msgid "День отправления"
msgstr ""

#: src/domains/push-notify/push-notify-access-request.tsx:39
msgid "Для получения уведомлений без запуска приложения требуется ваше разрешение. Обещаем не беспокоить вас по пустякам."
msgstr ""

#: src/pages/order-status/order-status.page.tsx:324
msgid "Для просмотра вашего билета нажмите на кнопку ниже."
msgstr ""

#: src/domains/push-notify/push-notify-settings.tsx:19
msgid "Для работы уведомлений необходимо добавить приложение на главный экран через меню на панели браузера"
msgstr ""

#: src/pages/buy-tickets/buy-tickets.tsx:22
msgid "Добавление пассажиров"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:312
#: src/pages/order-status/order-status.page.tsx:228
msgid "Если у вас не получилось произвести оплату, оплатить заказ можно по ссылке"
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:186
#: src/pages/sign-in/sign-in.page.tsx:80
msgid "Еще не зарегистрированны?"
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:186
#: src/pages/sign-in/sign-in.page.tsx:80
#~ msgid "Еще не зарегистрированы?"
#~ msgstr ""

#: src/domains/shared/refund-fee-express.tsx:41
msgid "За <0>20</0> минут до отправления поезда билет возврату не подлежит."
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:87
msgid "Забронирован"
msgstr ""

#: src/pages/sign-in/sign-in.page.tsx:62
#: src/pages/sign-up/sign-up.page.tsx:63
msgid "Забыли пароль?"
msgstr ""

#: src/pages/order-status/order-status.page.tsx:278
msgid "Заказ был забронирован"
msgstr ""

#: src/pages/order-status/order-status.page.tsx:283
msgid "Заказ был забронирован и ожидает завершения оплаты"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:298
#: src/pages/ticket-details/ticket-details.page.tsx:330
msgid "Заказ был забронирован и ожидает оплаты"
msgstr ""

#: src/pages/order-status/order-status.page.tsx:298
msgid "Заказ был отменен"
msgstr ""

#: src/pages/ticket-details/ticket-details.page.tsx:338
msgid "Заказ был отменен. Стоимость оплаченного билета будет возвращена с помощью выбранного способа оплаты (банковская карта)"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:276
#: src/pages/order-status/order-status.page.tsx:303
msgid "Заказ был отменен. Сумма заказа вернется на ваш счет"
msgstr ""

#: src/pages/order-status/order-status.page.tsx:319
msgid "Заказ был успешно оплачен"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:180
msgid "Заказ не найден. Попробуйте обновить страницу или вернуться к списку заказов"
msgstr ""

#: src/pages/order-status/order-status.page.tsx:218
msgid "Заказ обрабатывается"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:307
#: src/pages/order-status/order-status.page.tsx:223
#: src/pages/ticket-details/ticket-details.page.tsx:382
msgid "Заказ обрабатывается, ожидаем подтверждения оплаты"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:66
msgid "Заказ с ошибкой будет скрыт"
msgstr ""

#: src/domains/cabinet/pages/cabinet.index.page.tsx:59
msgid "Заказы"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:142
msgid "Заказы пока что отсутствуют"
msgstr ""

#: src/domains/sign-up/sign-up.tsx:173
#: src/pages/reset-password/reset-password.page.tsx:197
#: src/pages/sign-in/sign-in.page.tsx:90
msgid "Зарегистрироваться"
msgstr ""

#: src/domains/buy-ticket/buy-ticket.tsx:299
#: src/domains/buy-ticket/buy-ticket.tsx:327
msgid "Изменить данные"
msgstr ""

#: src/domains/buy-ticket/buy-ticket.tsx:271
msgid "Изменить данные пассажиров"
msgstr ""

#: src/pages/sign-in/sign-in.page.tsx:73
#: src/pages/sign-up/sign-up.page.tsx:74
msgid "Изменить пароль"
msgstr ""

#: src/features/main-side-menu/main-side-menu.tsx:54
msgid "История заказов"
msgstr ""

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:54
msgid "Итого"
msgstr ""

#: src/pages/search/seach-routes-loading.tsx:17
msgid "Ищем доступные маршруты..."
msgstr ""

#: src/domains/push-notify/push-notify-access-request.tsx:32
msgid "Кажется, Вы запретили приложению присылать вам уведомления. Для получения уведомлений зайдите в настройки телефона и разрешите показывать уведомления для \"pass.railway.am\" или Railway AM"
msgstr ""

#: src/domains/push-notify/push-notify-access-request.tsx:26
msgid "Кажется, Вы запретили приложению присылать вам уведомления. Для получения уведомлений зайдите в настройки телефона и разрешите показывать уведомления для Railway AM"
msgstr ""

#: src/domains/reset-password/change-pass.form.tsx:59
#: src/domains/sign-up/sign-up.tsx:158
msgid "Код подтверждения"
msgstr ""

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:118
msgid "Количество пассажиров:"
msgstr ""

#: src/domains/cabinet/pages/cabinet.index.page.tsx:37
#: src/features/main-side-menu/main-side-menu.tsx:36
#: src/pages/logout/logout.page.tsx:49
msgid "Личный кабинет"
msgstr ""

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:52
#~ msgid "Любое свободное"
#~ msgstr ""

#: src/domains/available-routes/features/available-routes/available-routes.tsx:150
#: src/domains/buy-ticket/pay-confirm.tsx:26
msgid "Маршрут"
msgstr ""

#: src/pages/search/search.page.tsx:138
msgid "Маршруты не найдены"
msgstr ""

#: src/domains/buy-ticket/select-seats.tsx:95
msgid "Места выбраны"
msgstr ""

#: src/domains/cabinet/pages/cabinet.index.page.tsx:50
#: src/features/main-side-menu/main-side-menu.tsx:45
#: src/pages/my-tickets/my-tickets.page.tsx:52
#: src/pages/order-details/order-details.page.tsx:144
#: src/pages/order-details/order-details.page.tsx:289
#: src/pages/order-details/order-details.page.tsx:341
#: src/pages/order-status/order-status.page.tsx:140
#: src/pages/order-status/order-status.page.tsx:200
#: src/pages/order-status/order-status.page.tsx:261
#: src/pages/ticket-details/ticket-details.page.tsx:163
#: src/pages/ticket-details/ticket-details.page.tsx:199
#: src/pages/ticket-details/ticket-details.page.tsx:371
#: src/pages/ticket-details/ticket-details.page.tsx:410
msgid "Мои билеты"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:129
#: src/pages/order-details/order-details.page.tsx:192
msgid "Мои заказы"
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:134
msgid "Мы отправим код подтверждения на указанный номер телефона"
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:129
msgid "На следующем шаге нужно ввести код подтверждения и новый пароль"
msgstr ""

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:28
#~ msgid "Название тарифа"
#~ msgstr ""

#: src/domains/available-routes/features/available-routes/available-routes.tsx:171
msgid "Найти билеты"
msgstr ""

#: src/domains/cabinet/pages/cabinet.index.page.tsx:81
#: src/domains/push-notify/push-notify.page.tsx:46
msgid "Настройка уведомлений"
msgstr ""

#: src/domains/push-notify/push-notify.page.tsx:46
#~ msgid "Настройки уведомлений"
#~ msgstr ""

#: src/domains/available-routes/features/available-routes/available-routes.tsx:69
msgid "Начальная и конечная станции совпадают"
msgstr ""

#: src/components/tickets-count/tickets-count.tsx:70
msgid "Не найдены билеты с тарифами по выбранному маршруту."
msgstr ""

#: src/domains/push-notify/use-push-notify-perms.ts:55
#: src/domains/push-notify/use-push-notify-perms.ts:136
msgid "Не получилось создать подписку на уведомления. Попробуйте перезапустить приложение"
msgstr ""

#: src/domains/push-notify/use-push-notify-perms.ts:234
msgid "Не удалось выполнить подписку в приложении"
msgstr ""

#: src/pages/buy-tickets/buy-tickets.tsx:54
msgid "Неверные параметры в строке адреса. Начните поиск билетов заново"
msgstr ""

#: src/components/search-route-card/search-route-card-data.tsx:32
msgid "Нет свободных мест"
msgstr ""

#: src/domains/reset-password/change-pass.form.tsx:69
msgid "Новый пароль"
msgstr ""

#: src/pages/ticket-details/ticket-details.page.tsx:74
msgid "Номер заказа"
msgstr ""

#: src/domains/buy-ticket/pay-confirm.tsx:22
#: src/pages/order-details/order-details.page.tsx:43
#: src/pages/order-status/order-status.page.tsx:354
msgid "Номер платежа"
msgstr ""

#: src/pages/ticket-details/trip-data/trip-data.tsx:23
msgid "Номер рейса"
msgstr ""

#: src/domains/reset-password/change-pass.form.tsx:36
#: src/domains/reset-password/login.form.tsx:25
#: src/domains/sign-in/sign-in.tsx:98
#: src/domains/sign-up/sign-up.tsx:117
msgid "Номер телефона"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:333
#: src/pages/order-status/order-status.page.tsx:192
#: src/pages/order-status/order-status.page.tsx:253
#: src/pages/ticket-details/ticket-details.page.tsx:362
#: src/pages/ticket-details/ticket-details.page.tsx:401
msgid "Обновить статус"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:43
msgid "Ожидает оплаты"
msgstr ""

#: src/domains/buy-ticket/pay-confirm.tsx:24
#: src/pages/order-details/order-details.page.tsx:48
#: src/pages/order-status/order-status.page.tsx:361
msgid "Описание"
msgstr ""

#: src/domains/buy-ticket/buy-ticket.tsx:291
#: src/domains/buy-ticket/buy-ticket.tsx:319
msgid "Оплатить"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:58
msgid "Оплачен"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:55
msgid "Оплачено"
msgstr ""

#: src/domains/feedback/reviews.page.tsx:170
msgid "Оставить отзыв"
msgstr ""

#: src/pages/ticket-details/ticket-details.page.tsx:297
msgid "Отзыв о поездке"
msgstr ""

#: src/domains/cabinet/pages/cabinet.index.page.tsx:68
#: src/domains/feedback/reviews.page.tsx:60
#: src/domains/feedback/reviews.page.tsx:99
msgid "Отзывы"
msgstr ""

#: src/domains/feedback/grade-title.ts:12
msgid "Отлично"
msgstr ""

#: src/domains/cabinet/features/tickets/refund-ticket-button.tsx:75
msgid "Отмена"
msgstr ""

#: src/domains/cabinet/features/tickets/refund-ticket-button.tsx:49
msgid "Отмена заказа"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:101
msgid "Отменен"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:73
msgid "Отмененный заказ будет скрыт"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:58
msgid "Отменить заказ"
msgstr ""

#: src/domains/reset-password/change-pass.form.tsx:76
#: src/domains/reset-password/login.form.tsx:45
msgid "Отправить код"
msgstr ""

#: src/domains/feedback/add-feedback-form.tsx:75
msgid "Отправить отзыв"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:133
#: src/pages/order-status/order-status.page.tsx:129
#: src/pages/ticket-details/ticket-details.page.tsx:152
msgid "Отсутствует ID платежа. Купленные билеты можно посмотреть в разделе \"Мои билеты\""
msgstr ""

#: src/pages/push-notify-rate-trip/push-notify-rate-trip.page.tsx:90
msgid "Отсутствуют необходимые параметры в адресе страницы. Оцените поездку в приложении"
msgstr ""

#: src/domains/feedback/reviews.page.tsx:177
msgid "Оцененные поездки"
msgstr ""

#: src/pages/push-notify-rate-trip/push-notify-rate-trip.page.tsx:78
#: src/pages/ticket-details/ticket-details.page.tsx:291
msgid "Оцените поездку"
msgstr ""

#: src/domains/feedback/grade-title.ts:7
msgid "Оценка отсутствует"
msgstr ""

#: src/domains/feedback/grade-title.ts:8
msgid "Очень плохо"
msgstr ""

#: src/pages/main/notification-center.tsx:47
msgid "Очистить все"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:73
msgid "Ошибка"
msgstr ""

#: src/pages/order-status/order-status.page.tsx:171
msgid "Ошибка при обработке заказа"
msgstr ""

#: src/domains/push-notify/use-push-notify-perms.ts:144
msgid "Ошибка при подписке на уведомления. Попробуйте позднее"
msgstr ""

#: src/domains/sign-in/sign-in.tsx:122
#: src/domains/sign-up/sign-up.tsx:139
msgid "Пароль"
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:160
msgid "Пароль был успешно изменен"
msgstr ""

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:39
msgid "Пассажир"
msgstr ""

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:109
#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:25
msgid "Пассажиры"
msgstr ""

#: src/domains/buy-ticket/redirect-to-bank.tsx:24
#: src/pages/order-status/order-status.page.tsx:234
msgid "Перейти к оплате"
msgstr ""

#: src/domains/buy-ticket/select-seats.tsx:111
msgid "Перейти к оформлению"
msgstr ""

#: src/pages/buy-tickets/buy-tickets.tsx:30
msgid "Переход к банку"
msgstr ""

#: src/domains/feedback/grade-title.ts:9
msgid "Плохо"
msgstr ""

#: src/pages/search/search.page.tsx:142
msgid "Повторить поиск"
msgstr ""

#: src/domains/push-notify/push-notify-settings.tsx:53
msgid "Подписка на уведомления"
msgstr ""

#: src/pages/buy-tickets/buy-tickets.tsx:28
msgid "Подтверждение платежа"
msgstr ""

#: src/domains/feedback/reviews.page.tsx:131
msgid "Поездки без отзыва"
msgstr ""

#: src/domains/feedback/reviews.page.tsx:73
#: src/domains/feedback/reviews.page.tsx:113
msgid "Поездки пока что отсутствуют"
msgstr ""

#: src/domains/feedback/add-feedback-form.tsx:40
msgid "Пожалуйста, выберите оценку"
msgstr ""

#: src/domains/available-routes/features/available-routes/available-routes.tsx:68
#: src/domains/available-routes/features/available-routes/available-routes.tsx:74
#: src/domains/reset-password/change-pass.form.tsx:28
#: src/domains/reset-password/change-pass.form.tsx:29
#: src/domains/reset-password/login.form.tsx:18
#: src/domains/sign-in/sign-in.tsx:36
#: src/domains/sign-in/sign-in.tsx:37
#: src/domains/sign-up/sign-up.tsx:97
#: src/domains/sign-up/sign-up.tsx:98
#: src/domains/sign-up/sign-up.tsx:109
msgid "Пожалуйста, заполните поле"
msgstr ""

#: src/domains/sign-up/sign-up.tsx:103
msgid "Пожалуйста, проверьте правильность email"
msgstr ""

#: src/features/main-side-menu/main-side-menu.tsx:27
msgid "Поиск билетов"
msgstr ""

#: src/pages/search/search.page.tsx:44
msgid "Поиск маршрутов"
msgstr ""

#: src/components/ticket-qr/ticket-qr.tsx:20
msgid "Покажите QR код проводнику в поезде"
msgstr ""

#: src/pages/my-tickets/my-tickets.page.tsx:114
#: src/pages/order-details/order-details.page.tsx:359
#: src/pages/order-status/order-status.page.tsx:344
msgid "Показать билет"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:203
msgid "Показать заказ"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:318
#: src/pages/ticket-details/ticket-details.page.tsx:387
msgid "Попробуйте обновить статус, либо проверить купленные билеты в разделе \"Мои билеты\""
msgstr ""

#: src/pages/order-status/order-status.page.tsx:237
msgid "Попробуйте обновить статус, либо проверить купленные билеты в разделе <0>Мои билеты</0>"
msgstr ""

#: src/components/tickets-count/tickets-count.tsx:71
msgid "Попробуйте проверить или выбрать другой маршрут"
msgstr ""

#: src/components/tickets-price/tickets-price.tsx:68
msgid "После оплаты Вам будет доступен QR-код. Покажите его сотруднику ЮКЖД в поезде на просьбу предъявить билет для проверки"
msgstr ""

#: src/domains/feedback/reviews.page.tsx:220
msgid "Посмотреть отзыв"
msgstr ""

#: src/domains/shared/refund-fee-express.tsx:35
msgid "При возврате билета за <0>1</0> час до отправления поезда от стоимости билета с пассажира удерживается <1>750</1> драм."
msgstr ""

#: src/domains/shared/refund-fee-express.tsx:23
msgid "При возврате билета за <0>24</0> часа до отправления поезда от стоимости билета с пассажира удерживается <1>300</1> драм."
msgstr ""

#: src/domains/shared/refund-fee-express.tsx:29
msgid "При возврате билета за <0>6</0> часов до отправления поезда от стоимости билета с пассажира удерживается <1>500</1> драм."
msgstr ""

#: src/domains/buy-ticket/agreement.tsx:20
msgid "При возврате группового билета возврату подлежат все места. Возврат отдельного места не производится."
msgstr ""

#: src/components/tickets-price/tickets-price.tsx:63
#~ msgid "При возврате группового билета возврату подлежат все места. Возврат отдельного места не производится."
#~ msgstr ""

#: src/pages/order-details/order-details.page.tsx:267
#: src/pages/order-status/order-status.page.tsx:178
#: src/pages/ticket-details/ticket-details.page.tsx:351
msgid "При обработке платежа произошла ошибка"
msgstr ""

#: src/components/search-route-card/search-route-card-data.tsx:34
msgid "Приобрести билеты"
msgstr ""

#: src/domains/buy-ticket/buy-ticket.tsx:235
msgid "Продолжить"
msgstr ""

#: src/pages/buy-tickets/buy-tickets.tsx:32
msgid "Пустой заголовок"
msgstr ""

#: src/domains/tz-notify/tz-notify.tsx:20
msgid "Расписание движения поездов не изменится."
msgstr ""

#: src/pages/main/main.page.tsx:103
#: src/pages/sign-up/sign-up.page.tsx:49
msgid "Регистрация"
msgstr ""

#: src/domains/tz-notify/tz-notify.tsx:11
msgid "С 08.10.2023 на сайте будет отображаться <0>местное время <1>(г. Ереван, GMT+4)</1></0> для отправления и прибытия поездов."
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:120
msgid "Сброс пароля"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:65
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:72
msgid "Скрыть заказ"
msgstr ""

#: src/domains/buy-ticket/select-payment-type.tsx:12
msgid "Создать платеж"
msgstr ""

#: src/components/ui/ui-fullscreen-select/select-search-list.tsx:51
msgid "Станции отсутствуют"
msgstr ""

#: src/domains/available-routes/features/available-routes/available-routes.tsx:153
msgid "Станция назначения"
msgstr ""

#: src/domains/available-routes/features/available-routes/available-routes.tsx:152
msgid "Станция отправления"
msgstr ""

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:32
msgid "Стоимость"
msgstr ""

#: src/pages/order-details/order-details.page.tsx:51
#: src/pages/order-status/order-status.page.tsx:363
msgid "Стоимость билетов"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:47
msgid "Стоимость оплаченного билета будет возвращена с помощью выбранного способа оплаты (банковская карта)"
msgstr ""

#: src/router/router.tsx:171
msgid "Страница не найдена"
msgstr ""

#: src/components/tickets-price/tickets-price.tsx:55
msgid "Сумма"
msgstr ""

#: src/pages/my-orders/my-orders.page.tsx:191
msgid "Сумма:"
msgstr ""

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:175
#: src/pages/ticket-details/ticket-details.page.tsx:286
msgid "Тарифы"
msgstr ""

#: src/pages/reset-password/reset-password.page.tsx:163
msgid "Теперь вы можете войти в личный кабинет используя новый пароль"
msgstr ""

#: src/pages/ticket-details/trip-data/trip-data.tsx:30
msgid "Тип состава"
msgstr ""

#: src/domains/feedback/reviews.page.tsx:121
msgid "У вас нет отзывов о поездках или нет поездок, которые можно оценить."
msgstr ""

#: src/domains/push-notify/push-notify-access-request.tsx:46
#: src/domains/push-notify/push-notify.page.tsx:34
#: src/domains/push-notify/use-push-notify-perms.ts:233
#: src/pages/main/notification-center.tsx:35
msgid "Уведомления"
msgstr ""

#: src/domains/feedback/grade-title.ts:10
msgid "Удовлетворительно"
msgstr ""

#: src/pages/sign-up/sign-up.page.tsx:81
msgid "Уже зарегистрированны?"
msgstr ""

#: src/pages/buy-tickets/buy-tickets.tsx:26
msgid "Условия возврата"
msgstr ""

#: src/domains/feedback/grade-title.ts:11
msgid "Хорошо"
msgstr ""

#: src/domains/feedback/add-feedback-form.tsx:54
msgid "Хотите оставить сообщение?"
msgstr ""

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:81
msgid "Что-то пошло не так. Неизвестный статус заказа"
msgstr ""

#: src/pages/main/main.page.tsx:85
msgid "Электрички Армении"
msgstr ""
